import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Alert } from '@mui/material';

interface PlatformAdminRouteProps {
  children: React.ReactNode;
}

export const PlatformAdminRoute: React.FC<PlatformAdminRouteProps> = ({ children }) => {
  const { user, loading, isPlatformAdmin } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isPlatformAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          You do not have permission to access this page. This area is restricted to platform administrators only.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};
